import tippy, { Instance } from 'tippy.js'

interface IDomFields {
  date: HTMLElement
  priceTotal: HTMLElement
  pricePerDay: HTMLElement
}

export interface IOptions {
  container: HTMLElement
  domFields?: IDomFields
  buttonTooltips?: Array<Instance>
  buttonsContainer?: NodeListOf<HTMLElement>
}

export class BookingDetails {
  options: IOptions

  constructor(options: IOptions) {
    this.options = { ...options }
    this.setDefaultSettings()
    this.handleSubmit()
    this.setButtonTooltip()
  }

  private setDefaultSettings() {
    const { container } = this.options

    if (container) {
      this.options = {
        ...this.options,
        domFields: {
          date: container.querySelector('.booking-details-item[data-name="date"]') as HTMLElement,
          priceTotal: container.querySelector('.booking-details-item[data-name="price_total"]') as HTMLElement,
          pricePerDay: container.querySelector('.booking-details-item[data-name="price_per_day"]') as HTMLElement,
        },
        buttonTooltips: [],
        buttonsContainer: container.querySelectorAll('.button-container'),
      }
    }
  }

  private handleSubmit() {
    const { container } = this.options

    if (container) {
      const button = container.querySelector('.booking-question-button') as HTMLElement
      const modalForm = document.querySelector('#modal-booking-question form') as HTMLFormElement

      if (button && modalForm) {
        const dateField = modalForm.querySelector('.form-field--date .date') as HTMLElement

        button.addEventListener('click', e => {
          e.preventDefault()

          const calendarForm = button.closest('form') as HTMLFormElement
          if (calendarForm) {
            const formDate = calendarForm.querySelector(
              '.booking-details-item[data-name="date"] .booking-details-item__value-title',
            ) as HTMLElement

            const date = formDate ? formDate.innerText : ''

            modalForm.date.value = date
            modalForm.post_id.value = jsData.post_id
            dateField.innerText = date
          }
        })
      }
    }
  }

  private setButtonTooltip() {
    const { buttonsContainer, buttonTooltips } = this.options

    if (buttonsContainer && buttonTooltips) {
      buttonsContainer.forEach(button => {
        buttonTooltips.push(tippy(button))
      })
    }
  }

  public setActiveButtons() {
    const { buttonsContainer, buttonTooltips } = this.options

    if (buttonsContainer && buttonTooltips) {
      buttonsContainer.forEach(buttonContainer => {
        const button = buttonContainer.querySelector('.btn') as HTMLButtonElement
        button.removeAttribute('disabled')
        buttonTooltips.forEach(tooltip => tooltip.destroy())
      })
    }
  }
}
